import { occupationEntityName } from '@juvare/credentialing/backend/config/shared';
import { getBooleanStringValue } from '@juvare/credentialing/backend/utils';
export function getShiftPositionAccountFilter({ deploymentDurations, position, }) {
    const shiftPositionAccountFilter = [];
    if (position.occupationIds && position.occupationIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'occupationIds',
            op: 'overlap',
            value: position.occupationIds,
        });
    }
    if (position.groupIds && position.allOccupations) {
        shiftPositionAccountFilter.push({
            column: 'occupationIds',
            op: 'overlap',
            subFilter: {
                entity: occupationEntityName,
                filter: [
                    {
                        column: 'groupId',
                        op: 'in',
                        value: position.groupIds,
                    },
                ],
            },
        });
    }
    if (position.ecl && position.ecl.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'ecls',
            op: 'overlap',
            value: position.ecl,
        });
    }
    if (position.skillIds && position.skillIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'skillIds',
            op: 'contains',
            value: position.skillIds,
        });
    }
    if (position.trainingIds && position.trainingIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'trainingCourseIds',
            op: 'contains',
            value: position.trainingIds,
        });
    }
    if (position.languageIds && position.languageIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'languageIds',
            op: 'contains',
            value: position.languageIds,
        });
    }
    if (position.state) {
        shiftPositionAccountFilter.push({
            column: 'state',
            op: '=',
            value: position.state,
        });
    }
    if (position.residenceType === 'county' && position.counties && position.counties.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'county',
            op: 'in',
            value: position.counties,
        });
    }
    if (position.residenceType === 'tribe' && position.tribeIds && position.tribeIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'tribeId',
            op: 'in',
            value: position.tribeIds,
        });
    }
    if (position.deploymentDurationId && deploymentDurations[position.deploymentDurationId] !== null) {
        shiftPositionAccountFilter.push({
            column: 'deploymentDuration',
            op: '>=',
            value: deploymentDurations[position.deploymentDurationId],
        });
    }
    if (position.deploymentTravelWillingnessIds && position.deploymentTravelWillingnessIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'deploymentTravelIds',
            op: 'overlap',
            value: position.deploymentTravelWillingnessIds,
        });
    }
    if (typeof position.federalDeploymentWillingness === 'boolean') {
        shiftPositionAccountFilter.push({
            column: 'workUnderFederalGovernment',
            op: '=',
            value: getBooleanStringValue(position.federalDeploymentWillingness),
        });
    }
    if (typeof position.priorCommitments === 'boolean') {
        shiftPositionAccountFilter.push({
            column: 'priorCommitment',
            op: '=',
            value: getBooleanStringValue(position.priorCommitments),
        });
    }
    return shiftPositionAccountFilter;
}
